export default "__VITE_ASSET__f1a3fa83__"